// Italian translations
const it = {
  translation: {
    // Common
    'app.name': 'Monitoraggio Remoto Visivo',
    'app.login': 'Accedi',
    'app.loginDemo': 'Demo Accedi',
    'app.register': 'Registrati',
    'app.logout': 'Esci',
    'common.dashboard': 'Dashboard',
    'common.installations': 'Elenco Impianti',
    'app.news': 'Novità',
    'news.overview': 'Panoramica novità',
    'news.searchPlaceholder': 'Cerca notizie...',
    'news.searchButton': 'Cerca',
    'news.noNewsFound': 'Nessuna notizia trovata.',
    'app.shop': 'Shop',

    // Gallery
    'gallery.title': 'Galleria Impianti',
    'gallery.share': 'Condividi',
    'gallery.shared': 'Condiviso',
    'gallery.pending': 'In Attesa',
    'gallery.noImages': 'Nessuna immagine',
    'gallery.like': 'Mi piace',
    'gallery.loginToLike': 'Accedi per votare',
    'gallery.loadError': 'Errore caricamento galleria',
    'common.uploadImagesSuccess': 'Caricamento riuscito',
    'common.uploadImagesFailed': 'Caricamento fallito',
    'gallery.deleteConfirm': 'Eliminare questa immagine?',
    'gallery.maxImages': 'Max {{max}} immagini',
    'gallery.caption': 'Descrizione immagine',
    'gallery.selectInstallation': 'Seleziona impianto',
    'gallery.selectFiles': 'Seleziona file immagine',
    'gallery.filesSelected': '{{count}} file selezionati',
    'gallery.selectInstallationAndFiles': 'Seleziona impianto e immagini',
    'gallery.shareToGallery': 'Condividi in galleria pubblica',
    'gallery.myImages': 'Le Mie Immagini',
    'gallery.publicGallery': 'Galleria Pubblica',
    'gallery.unshare': 'Rimuovi',
    'gallery.unshared': 'Rimosso',
    'gallery.subtitle': 'Condividi il tuo impianto solare',
    'gallery.dropOrClick': 'Trascina o clicca per selezionare',
    'gallery.private': 'Privato',
    'gallery.selectSource': 'Seleziona sorgente',
    'gallery.takePhoto': 'Scatta Foto',
    'gallery.chooseFromGallery': 'Scegli dalla Galleria',
    'gallery.captionPlaceholder': 'Descrivi il tuo impianto...',
    'gallery.shareHint': 'Consenti ad altri di vedere questa foto',
    'common.uploadImagesHint': 'Supporta JPG, PNG (max 10MB)',

    'common.devices': 'Dispositivi',
    'app.profile': 'Profilo',
    'common.settings': 'Impostazioni',
    'settings.verificationCode': 'Codice di verifica',
    'settings.sendCode': 'Invia codice',
    'settings.codeSentNotice': 'Codice di verifica inviato alla tua email',
    'settings.codeRequired': 'Inserisci il codice di verifica a 6 cifre',
    'app.language': 'Lingua',

    'app.email': 'Email',
    'common.password': 'Password',
    'app.username': 'Nome Utente',
    'app.confirmPassword': 'Conferma Password',
    'app.submit': 'Invia',
    'common.cancel': 'Annulla',
    'common.save': 'Salva',
    'common.set': 'Scrivi',
    'common.delete': 'Elimina',
    'common.add': 'Aggiungi',
    'common.upload': 'Carica',
    'common.edit': 'Modifica',
    'common.search': 'Cerca',
    'common.filter': 'Filtra',
    'common.sort': 'Ordina',
    'common.status': 'Stato',
    'common.online': 'Online',
    'common.offline': 'Offline',
    'common.error': 'Errore',
    'common.success': 'Successo',
    'app.back': 'Indietro',
    'app.home': 'Home',
    'common.actions': 'Azioni',
    'common.loading': 'Caricamento...',
    'common.processing': 'Elaborazione...',
    'common.close': 'Chiudi',
    'common.units': 'Unità',
    'common.normal': 'Normale',
    'common.tooHigh': 'Troppo Alto',
    'common.tooLow': 'Troppo Basso',
    'common.number': 'Numero',
    'common.time': 'Ora',
    'common.overview': 'Panoramica',
    'common.details': 'Dettagli',
    'common.rowsPerPage': 'Righe per pagina',
    'common.readMore': 'Leggi di più',
    // Unified terms (reuse across pages)
    'common.voltage': 'Voltaggio',
    'common.current': 'Corrente',
    'common.power': 'Potenza',
    'common.temperature': 'Temperatura',
    'common.soc': 'SOC',
    'common.charging': 'In Carica',
    'common.discharging': 'In Scarica',
    'common.idle': 'Inattivo',
    'common.warning': 'Avviso',
    'common.warnState1': 'Avviso Stato 1',
    'common.warnState2': 'Avviso Stato 2',
    'common.cell': 'Cella',
    'common.avgVoltage': 'Voltaggio Medio',
    'common.avgTemperature': 'Temp. Media',
    'common.totalCurrent': 'Corrente Totale',
    'common.totalPower': 'Potenza Totale',
    'common.fullyCharged': 'Completamente Carica',
    'common.user': 'Utente',
    'common.deviceId': 'ID Dispositivo',
    'common.unknownWarning': 'Avviso Sconosciuto',
    'common.admin': 'Admin',
    'common.protection': 'Protezione',
    'common.fault': 'Guasto',
    'common.calibration': 'Calibrazione',
    'common.refresh': 'Aggiorna Dati',
    'common.addDevice': 'Aggiungi Disp.',
    'common.deviceAdded': 'Dispositivo aggiunto',
    'common.cycleCount': 'Cicli di Carica',
    'common.soh': 'SOH',
    'common.realtime': 'Monitoraggio Real-time',
    'common.batteryPackTitle': 'Pacco Batteria #{{index}}',
    'common.remainCapacityAh': 'Capacità Residua (Ah)',
    'common.fullChargeCapacityAh': 'Capacità Piena (Ah)',
    'common.designCapacityAh': 'Capacità Nominale (Ah)',
    'common.backToDetail': 'Torna ai Dettagli Impianto',
    'common.loadDeviceFailed': 'Errore caricamento dettagli',
    'common.permissionsManagement': 'Gestione Permessi',
    'common.shortCircuitProt': 'Prot. Cortocircuito',
    'common.startDate': 'Data Inizio',
    'common.endDate': 'Data Fine',
    // Status & States
    'common.expired': 'Scaduto',
    // Actions
    'common.create': 'Crea',
    // Time-related
    'common.day': 'giorno',
    'common.days': 'giorni',
    'common.createdAt': 'Creato il',
    'common.expiry': 'Data Scadenza',
    'common.expiryDays': 'Periodo Validità (gg)',
    // Battery-related
    'common.batteryPack': 'Pacco Batteria',
    'common.dischargeEnabled': 'Scarica Abilitata',
    'common.chargeEnabled': 'Carica Abilitata',
    'common.currentLimit': 'Limite Corrente',
    'common.charger': 'Caricabatterie',
    'common.avg': 'Media',


    // Device
    'device.lastConnection': 'Ultima Connessione',
    'device.delete': 'Elimina Impianto',
    'device.view': 'Visualizza Disp.',
    'device.notFound': 'Dispositivo non trovato',
    'device.deleteSuccess': 'Impianto eliminato',
    'device.confirmDelete': 'Eliminare questo impianto?',
    'device.info': 'Informazioni Impianto',
    'device.details': 'Dettagli Dispositivo',
    'device.never': 'Mai',
    'device.errorMissingFields': 'Compila tutti i campi richiesti',
    'device.idHelp': 'Inserisci un ID univoco per il dispositivo',
    'device.nameHelp': 'Assegna un nome al dispositivo',
    'device.loading': 'Caricamento dispositivi...',
    'common.justNow': 'Proprio ora',
    'device.minutesAgo': 'minuti fa',
    'device.hoursAgo': 'ore fa',
    'device.noDevicesDesc': 'Non hai ancora aggiunto dispositivi. Clicca il pulsante qui sotto per aggiungere il primo.',
    'device.deleting': 'Eliminazione...',
    'device.noConnections': 'Nessuna connessione recente',
    'device.type': 'Tipo Dispositivo',
    'device.optionalInfo': 'Info Opzionali',
    'device.optionalInfoTooltip': 'Compilare queste informazioni aiuta a fornire un migliore supporto post-vendita',
    'device.inverterBrand': 'Marca Inverter',
    'device.inverterModel': 'Modello Inverter',
    'device.solarPower': 'Potenza Solare (kW)',
    'device.city': 'Città Impianto',
    'device.description': 'Descrizione Impianto',
    'device.updatedAt': 'Aggiornato il',

    // Battery data
    'battery.status': 'Stato Carica',
    'battery.data': 'Dati Batteria',
    'battery.history': 'Storico',
    'battery.protectionRecord': 'Record Protezioni',
    'battery.balance': 'Corrente Bilanciamento',
    'battery.cells': 'Numero Celle',
    'battery.noData': 'Nessun dato disponibile',
    'battery.historyCharts': 'Grafici Storico',
    'battery.resetZoom': 'Reimposta',

    'battery.cellData': 'Dati Celle',
    'battery.cellVoltageData': 'Dati Voltaggio Celle',
    'battery.temperatureData': 'Dati Sensori Temp.',
    'battery.cellDataUnavailable': 'Dati celle temporaneamente non disponibili, visualizzazione dati precedenti...',
    'battery.tempDataUnavailable': 'Dati sensori temperatura temporaneamente non disponibili, visualizzazione dati precedenti...',
    'battery.cellVoltageTable': 'Tabella Voltaggio Celle',
    'battery.tempDataTable': 'Tabella Dati Sensori Temp.',
    'battery.cellStats': 'Statistiche Celle',
    'battery.activeBalancing': 'Bilanciamento Attivo',
    'battery.activeBalancingOn': 'In Bilanciamento',
    'battery.heaterEnabled': 'Riscaldamento Attivo',
    'battery.currentLimitEnabled': 'Limite Corrente Attivo',
    'battery.highest': 'Massimo',
    'battery.lowest': 'Minimo',
    'battery.highestVoltage': 'Voltaggio Max',
    'battery.lowestVoltage': 'Voltaggio Min',
    'battery.volDiff': 'Differenza Voltaggio',
    'battery.totalCells': 'Celle Totali',
    'battery.temperatureSensors': 'Sensori Temperatura',
    'battery.temperatureStats': 'Statistiche Temperatura',
    'battery.sensorCount': 'Numero Sensori',
    'battery.highestTemperature': 'Temp. Massima',
    'battery.lowestTemperature': 'Temp. Minima',
    'battery.faultState': 'Stato Guasto',
    'battery.protectState1': 'Stato Protezione 1',
    'battery.protectState2': 'Stato Protezione 2',

    // Warning titles
    'warning.title': 'Informazioni Avvisi',
    'warning.current': 'Avvisi Attuali',
    'warning.normal': 'Stato batteria normale, nessun avviso',
    'warning.noWarning': 'Nessun Avviso',

    // Warning states

    // Protection state related
    'warning.protect_high_discharge_current': 'Prot. Sovracorrente Scarica',
    'warning.protect_high_charge_current': 'Prot. Sovracorrente Carica',
    'warning.protect_low_total_voltage': 'Prot. Sottotensione Totale',
    'warning.protect_high_total_voltage': 'Prot. Sovratensione Totale',
    'warning.protect_low_cell_voltage': 'Prot. Sottotensione Cella',
    'warning.protect_high_cell_voltage': 'Prot. Sovratensione Cella',
    'warning.protect_low_env_temp': 'Prot. Temp. Ambiente Bassa',
    'warning.protect_high_env_temp': 'Prot. Temp. Ambiente Alta',
    'warning.protect_high_mos_temp': 'Prot. Temp. MOS Alta',
    'warning.protect_low_discharge_temp': 'Prot. Temp. Scarica Bassa',
    'warning.protect_low_charge_temp': 'Prot. Temp. Carica Bassa',
    'warning.protect_high_discharge_temp': 'Prot. Temp. Scarica Alta',
    'warning.protect_high_charge_temp': 'Prot. Temp. Carica Alta',

    // Command state related
    'battery.reverse_connected': 'Connessione Batteria Invertita',

    // Fault state related
    'warning.fault_sampling': 'Guasto Campionamento',
    'warning.fault_cell': 'Guasto Cella',
    'warning.fault_ntc': 'Guasto Sensore Temp.',
    'warning.fault_discharge_mos': 'Guasto MOS Scarica',
    'warning.fault_charge_mos': 'Guasto MOS Carica',
    'warning.fault_adapter_temp': 'Surriscaldamento Scheda Adattatore',
    'warning.fault_virtual_connection': 'Connessione Virtuale Batteria',
    'warning.fault_communication': 'Guasto Comunicazione',
    'warning.fault_ccb': 'Guasto CCB',
    'warning.fault_heater': 'Guasto Riscaldatore',
    'warning.fault_12v': 'Guasto Alim. 12V',
    'warning.fault_total_voltage': 'Guasto Voltaggio Totale',
    'warning.fault_temp_diff': 'Guasto Differenza Temp.',
    'warning.fault_detect_resistor': 'Guasto Resistenza Rilevamento',
    'warning.fault_trip_unit': 'Guasto Unità Interruttore',
    'warning.fault_master_slave': 'Guasto Com. Master/Slave',
    'warning.fault_bms_lock': 'BMS Bloccato',
    'warning.fault_mcu_overvoltage': 'Sovratensione MCU',

    'warning.protect_short_circuit': 'Prot. Cortocircuito',
    'warning.protect_charger_overvoltage': 'Prot. Sovratensione Caricab.',
    'warning.protect_full_charge': 'Prot. Carica Completa',

    // Status indicators
    'status.limit_current_on': 'Limite Corrente ON',
    'status.limit_current_off': 'Limite Corrente OFF',
    'status.charge_mos_on': 'MOS Carica ON',
    'status.charge_mos_off': 'MOS Carica OFF',
    'status.discharge_mos_on': 'MOS Scarica ON',
    'status.discharge_mos_off': 'MOS Scarica OFF',
    'status.charger_connected': 'Caricabatterie Connesso',
    'status.charger_disconnected': 'Caricabatterie Scollegato',
    'status.heater_on': 'Riscaldatore ON',
    'status.heater_off': 'Riscaldatore OFF',

    // Warning state 1 related
    'warning.warn_high_discharge_current': 'Avviso Alta Corrente Scarica',
    'warning.warn_high_charge_current': 'Avviso Alta Corrente Carica',
    'warning.warn_low_total_voltage': 'Avviso Basso Voltaggio Totale',
    'warning.warn_high_total_voltage': 'Avviso Alto Voltaggio Totale',
    'warning.warn_low_cell_voltage': 'Avviso Basso Voltaggio Cella',
    'warning.warn_high_cell_voltage': 'Avviso Alto Voltaggio Cella',

    // Warning state 2 related
    'warning.warn_low_soc': 'Avviso SOC Basso',
    'warning.warn_high_mos_temp': 'Avviso Temp. MOS Alta',
    'warning.warn_low_env_temp': 'Avviso Temp. Ambiente Bassa',
    'warning.warn_high_env_temp': 'Avviso Temp. Ambiente Alta',
    'warning.warn_low_discharge_temp': 'Avviso Temp. Scarica Bassa',
    'warning.warn_low_charge_temp': 'Avviso Temp. Carica Bassa',
    'warning.warn_high_discharge_temp': 'Avviso Temp. Scarica Alta',
    'warning.warn_high_charge_temp': 'Avviso Temp. Carica Alta',

    // Warning states
    'warning.below_lower_limit': 'Sotto Limite Inferiore',
    'warning.above_upper_limit': 'Sopra Limite Superiore',
    'warning.user_defined': 'Avviso Definito Utente',
    'warning.other_fault': 'Altro Guasto',

    // Warning descriptions (for tooltip) - full translation
    'warningDesc.warn_low_soc': 'Il SOC della batteria è al di sotto della soglia di sicurezza, si prega di ricaricare tempestivamente',
    'warningDesc.warn_high_mos_temp': 'La temperatura del MOS è troppo alta, il che potrebbe influenzare l\'efficienza di carica/scarica',
    'warningDesc.warn_low_env_temp': 'La temperatura ambiente è troppo bassa, il che potrebbe influenzare le prestazioni della batteria',
    'warningDesc.warn_high_env_temp': 'La temperatura ambiente è troppo alta, si prega di prestare attenzione alla dissipazione del calore',
    'warningDesc.warn_low_discharge_temp': 'La temperatura di scarica è troppo bassa, la scarica è stata limitata',
    'warningDesc.warn_low_charge_temp': 'La temperatura di carica è troppo bassa, la carica è stata limitata',
    'warningDesc.warn_high_discharge_temp': 'La temperatura di scarica è troppo alta, la scarica è stata limitata',
    'warningDesc.warn_high_charge_temp': 'La temperatura di carica è troppo alta, la carica è stata limitata',
    'warningDesc.warn_high_discharge_current': 'La corrente di scarica supera il limite di sicurezza',
    'warningDesc.warn_high_charge_current': 'La corrente di carica supera il limite di sicurezza',
    'warningDesc.warn_low_total_voltage': 'Il voltaggio totale è al di sotto della soglia di sicurezza',
    'warningDesc.warn_high_total_voltage': 'Il voltaggio totale è al di sopra della soglia di sicurezza',
    'warningDesc.warn_low_cell_voltage': 'Il voltaggio della cella è troppo basso',
    'warningDesc.warn_high_cell_voltage': 'Il voltaggio della cella è troppo alto',
    'warningDesc.protect_high_discharge_current': 'La corrente di scarica è troppo alta, protezione attivata',
    'warningDesc.protect_high_charge_current': 'La corrente di carica è troppo alta, protezione attivata',
    'warningDesc.protect_short_circuit': 'Cortocircuito rilevato, protezione attivata',
    'warningDesc.protect_low_total_voltage': 'Il voltaggio totale è troppo basso, protezione attivata',
    'warningDesc.protect_high_total_voltage': 'Il voltaggio totale è troppo alto, protezione attivata',
    'warningDesc.protect_low_cell_voltage': 'Il voltaggio della cella è troppo basso, protezione attivata',
    'warningDesc.protect_high_cell_voltage': 'Il voltaggio della cella è troppo alto, protezione attivata',
    'warningDesc.protect_low_env_temp': 'La temperatura ambiente è troppo bassa, protezione attivata',
    'warningDesc.protect_high_env_temp': 'La temperatura ambiente è troppo alta, protezione attivata',
    'warningDesc.protect_high_mos_temp': 'La temperatura del MOS è troppo alta, protezione attivata',
    'warningDesc.protect_low_discharge_temp': 'La temperatura di scarica è troppo bassa, protezione attivata',
    'warningDesc.protect_low_charge_temp': 'La temperatura di carica è troppo bassa, protezione attivata',
    'warningDesc.protect_high_discharge_temp': 'La temperatura di scarica è troppo alta, protezione attivata',
    'warningDesc.protect_high_charge_temp': 'La temperatura di carica è troppo alta, protezione attivata',
    'warningDesc.fault_sampling': 'Il circuito di campionamento della batteria è anomalo, si prega di controllare l\'hardware',
    'warningDesc.fault_cell': 'Guasto alla cella della batteria, si prega di controllare il pacco batteria',
    'warningDesc.fault_ntc': 'Guasto al sensore di temperatura, impossibile misurare accuratamente la temperatura',
    'warningDesc.fault_discharge_mos': 'Guasto al MOS di scarica, impossibile scaricare normalmente',
    'warningDesc.fault_charge_mos': 'Guasto al MOS di carica, impossibile caricare normalmente',
    'warningDesc.fault_adapter_temp': 'La temperatura della scheda adattatore è troppo alta',
    'warningDesc.fault_virtual_connection': 'Il contatto della batteria è scarso, si prega di controllare la connessione',

    // Charging status constants

    // Authentication
    'auth.loginTitle': 'Accedi al tuo account',
    'auth.registerTitle': 'Crea nuovo account',
    'auth.forgotPassword': 'Password dimenticata?',
    'auth.noAccount': 'Non hai un account?',
    'auth.haveAccount': 'Hai già un account?',
    'auth.loginSuccess': 'Accesso effettuato',
    'auth.registerSuccess': 'Registrazione completata',
    'auth.registerFailed': 'Registrazione fallita',
    'auth.logoutSuccess': 'Logout effettuato',
    'auth.invalidCredentials': 'Email o password non validi',
    'auth.passwordMismatch': 'Le password non coincidono',
    'auth.emailExists': 'Email già esistente',
    'auth.usernameExists': 'Nome utente già esistente',
    'auth.managerEmail': 'Email admin (opzionale)',
    'auth.managerEmailHelp': 'Se conosci l\'email del tuo admin, inseriscila qui per unirti al suo team',
    'auth.invitationCode': 'Codice invito (opzionale)',
    'auth.invitationCodeHelp': 'Se hai un codice invito, inseriscilo qui',
    'auth.forgotPasswordDesc': 'Inserisci il tuo indirizzo email registrato e ti invieremo un link per reimpostare la password.',
    'auth.forgotPasswordSuccess': 'Email di reset inviata. Controlla la tua casella di posta.',
    'auth.invalidToken': 'Token Non Valido',
    'auth.tokenErrorDesc': 'Token di reset non valido o mancante. Accedi a questa pagina dal link nella tua email.',
    'auth.passwordUpdated': 'Password reimpostata con successo. Reindirizzamento al login...',
    'auth.resetPasswordTitle': 'Reimposta Password',

    // Settings
    'settings.about': 'Informazioni',
    'settings.aboutDesc': 'Home Battery IoT è un sistema di monitoraggio per dispositivi batteria domestici.',
    'settings.languageUpdated': 'Lingua aggiornata',
    'settings.updateFailed': 'Aggiornamento impostazioni fallito',
    'settings.changePassword': 'Cambia Password',
    'settings.currentPassword': 'Password Attuale',
    'settings.newPassword': 'Nuova Password',
    'settings.confirmPassword': 'Conferma Nuova Password',
    'settings.passwordUpdated': 'Password cambiata con successo',
    'settings.passwordMismatch': 'Le password non coincidono',
    'settings.passwordTooShort': 'La password deve essere di almeno 6 caratteri',
    'settings.usernameUpdated': 'Nome utente aggiornato',
    'settings.appearance': 'Impostazioni Aspetto',
    'settings.avatar': 'Avatar',
    'settings.changeAvatar': 'Cambia Avatar',
    'settings.avatarHint': 'Max 2MB, supporta JPG/PNG/GIF/WebP',
    'settings.avatarUpdated': 'Avatar aggiornato',
    'settings.invalidFileType': 'Seleziona un file immagine',
    'settings.fileTooLarge': 'File troppo grande, max 2MB',
    'settings.timezone': 'Fuso Orario',
    'settings.timezoneUpdated': 'Fuso orario aggiornato',

    // Timezone labels
    'timezones.UTC': 'UTC (Tempo Coordinato Universale)',
    'timezones.Europe/London': 'Londra (GMT/BST)',
    'timezones.Europe/Dublin': 'Dublino (GMT/IST)',
    'timezones.Europe/Paris': 'Parigi (CET/CEST)',
    'timezones.Europe/Berlin': 'Berlino (CET/CEST)',
    'timezones.Europe/Amsterdam': 'Amsterdam (CET/CEST)',
    'timezones.Europe/Brussels': 'Bruxelles (CET/CEST)',
    'timezones.Europe/Rome': 'Roma (CET/CEST)',
    'timezones.Europe/Madrid': 'Madrid (CET/CEST)',
    'timezones.Europe/Lisbon': 'Lisbona (WET/WEST)',
    'timezones.Europe/Vienna': 'Vienna (CET/CEST)',
    'timezones.Europe/Zurich': 'Zurigo (CET/CEST)',
    'timezones.Europe/Stockholm': 'Stoccolma (CET/CEST)',
    'timezones.Europe/Oslo': 'Oslo (CET/CEST)',
    'timezones.Europe/Copenhagen': 'Copenaghen (CET/CEST)',
    'timezones.Europe/Helsinki': 'Helsinki (EET/EEST)',
    'timezones.Europe/Warsaw': 'Varsavia (CET/CEST)',
    'timezones.Europe/Prague': 'Praga (CET/CEST)',
    'timezones.Europe/Athens': 'Atene (EET/EEST)',
    'timezones.Europe/Istanbul': 'Istanbul (TRT)',
    'timezones.Europe/Moscow': 'Mosca (MSK)',
    'timezones.America/New_York': 'New York (EST/EDT)',
    'timezones.America/Toronto': 'Toronto (EST/EDT)',
    'timezones.America/Chicago': 'Chicago (CST/CDT)',
    'timezones.America/Denver': 'Denver (MST/MDT)',
    'timezones.America/Phoenix': 'Phoenix (MST)',
    'timezones.America/Los_Angeles': 'Los Angeles (PST/PDT)',
    'timezones.America/Vancouver': 'Vancouver (PST/PDT)',
    'timezones.America/Anchorage': 'Anchorage (AKST/AKDT)',
    'timezones.Pacific/Honolulu': 'Honolulu (HST)',
    'timezones.America/Mexico_City': 'Città del Messico (CST/CDT)',
    'timezones.America/Bogota': 'Bogotà (COT)',
    'timezones.America/Lima': 'Lima (PET)',
    'timezones.America/Santiago': 'Santiago (CLT/CLST)',
    'timezones.America/Sao_Paulo': 'San Paolo (BRT)',
    'timezones.America/Buenos_Aires': 'Buenos Aires (ART)',
    // Middle East
    'timezones.Asia/Jerusalem': 'Gerusalemme (IST)',
    'timezones.Asia/Beirut': 'Beirut (EET/EEST)',
    'timezones.Asia/Amman': 'Amman (EET/EEST)',
    'timezones.Asia/Baghdad': 'Baghdad (AST)',
    'timezones.Asia/Kuwait': 'Kuwait (AST)',
    'timezones.Asia/Dubai': 'Dubai (GST)',
    'timezones.Asia/Muscat': 'Mascate (GST)',
    'timezones.Asia/Riyadh': 'Riyad (AST)',
    'timezones.Asia/Qatar': 'Doha (AST)',
    'timezones.Asia/Bahrain': 'Bahrein (AST)',
    'timezones.Asia/Tehran': 'Teheran (IRST)',
    // Central Asia
    'timezones.Asia/Kabul': 'Kabul (AFT)',
    'timezones.Asia/Karachi': 'Karachi (PKT)',
    'timezones.Asia/Tashkent': 'Tashkent (UZT)',
    'timezones.Asia/Almaty': 'Almaty (ALMT)',
    // South Asia
    'timezones.Asia/Kolkata': 'Mumbai / Nuova Delhi (IST)',
    'timezones.Asia/Colombo': 'Colombo (IST)',
    'timezones.Asia/Kathmandu': 'Kathmandu (NPT)',
    'timezones.Asia/Dhaka': 'Dhaka (BST)',
    'timezones.Asia/Yangon': 'Yangon (MMT)',
    // Southeast Asia
    'timezones.Asia/Bangkok': 'Bangkok (ICT)',
    'timezones.Asia/Ho_Chi_Minh': 'Ho Chi Minh (ICT)',
    'timezones.Asia/Jakarta': 'Giacarta (WIB)',
    'timezones.Asia/Singapore': 'Singapore (SGT)',
    'timezones.Asia/Kuala_Lumpur': 'Kuala Lumpur (MYT)',
    'timezones.Asia/Manila': 'Manila (PHT)',
    // East Asia
    'timezones.Asia/Hong_Kong': 'Hong Kong (HKT)',
    'timezones.Asia/Shanghai': 'Shanghai / Pechino (CST)',
    'timezones.Asia/Taipei': 'Taipei (CST)',
    'timezones.Asia/Seoul': 'Seoul (KST)',
    'timezones.Asia/Tokyo': 'Tokyo (JST)',
    // Oceania
    'timezones.Australia/Perth': 'Perth (AWST)',
    'timezones.Australia/Adelaide': 'Adelaide (ACST/ACDT)',
    'timezones.Australia/Brisbane': 'Brisbane (AEST)',
    'timezones.Australia/Sydney': 'Sydney (AEST/AEDT)',
    'timezones.Australia/Melbourne': 'Melbourne (AEST/AEDT)',
    'timezones.Pacific/Auckland': 'Auckland (NZST/NZDT)',
    // Africa (North)
    'timezones.Africa/Casablanca': 'Casablanca (WET/WEST)',
    'timezones.Africa/Algiers': 'Algeri (CET)',
    'timezones.Africa/Tunis': 'Tunisi (CET)',
    'timezones.Africa/Tripoli': 'Tripoli (EET)',
    'timezones.Africa/Cairo': 'Il Cairo (EET)',
    // Africa (East)
    'timezones.Africa/Khartoum': 'Khartum (CAT)',
    'timezones.Africa/Addis_Ababa': 'Addis Abeba (EAT)',
    'timezones.Africa/Nairobi': 'Nairobi (EAT)',
    // Africa (West)
    'timezones.Africa/Lagos': 'Lagos (WAT)',
    'timezones.Africa/Accra': 'Accra (GMT)',
    // Africa (South)
    'timezones.Africa/Johannesburg': 'Johannesburg (SAST)',
    'timezones.Africa/Cape_Town': 'Città del Capo (SAST)',

    'common.uploading': 'Caricamento...',

    // Errors
    'error.pageNotFound': 'Pagina Non Trovata',
    'error.pageNotFoundDesc': 'La pagina che stai cercando potrebbe essere stata eliminata, rinominata o temporaneamente non disponibile.',
    'error.fetchFailed': 'Errore nel recupero dei dati',
    'error.createFailed': 'Creazione fallita',
    'error.copyFailed': 'Copia fallita',
    'error.processFailed': 'Elaborazione richiesta fallita',

    // Admin
    'admin.dashboard': 'Dashboard Admin',
    'admin.superDashboard': 'Dashboard Superadmin',
    'admin.managedUsers': 'Utenti Gestiti',
    'admin.managedDevices': 'Dispositivi Gestiti',
    'admin.role': 'Ruolo',
    'admin.superadmin': 'Superadmin',
    'admin.noUsers': 'Nessun utente trovato',
    'admin.userList': 'Elenco Utenti',
    'admin.adminList': 'Elenco Admin',
    'admin.deviceList': 'Elenco Dispositivi',
    'admin.noAdmins': 'Nessun admin trovato',
    'admin.addAdmin': 'Aggiungi Admin',
    'admin.createError': 'Errore creazione admin',
    'admin.fillAllFields': 'Compila tutti i campi',
    'admin.deviceCount': 'Numero Dispositivi',
    'admin.assignManager': 'Assegna Admin',
    'admin.selectManager': 'Seleziona Admin',
    'admin.noManager': 'Nessun Admin (rimuovi)',
    'admin.assigningUser': 'Assegnazione utente',
    'admin.assign': 'Assegna',
    'admin.assignError': 'Errore assegnazione admin',
    'admin.self': 'Se stesso',
    'admin.active': 'Attivo',
    'admin.used': 'Usato',
    'admin.adminPanel': 'Pannello Admin',
    'admin.newsManagement': 'Gestione Novità',
    'admin.addNews': 'Aggiungi Novità',
    'admin.editNews': 'Modifica Novità',
    'admin.deleteNews': 'Elimina Novità',
    'admin.deleteNewsConfirm': 'Eliminare questo articolo?',
    'admin.newsTitle': 'Titolo',
    'admin.newsSummary': 'Riepilogo',
    'admin.newsContent': 'Contenuto',
    'admin.newsImageUrl': 'URL Immagine',
    'admin.newsPublished': 'Pubblicato',
    'admin.newsDraft': 'Bozza',
    'admin.newsStatus': 'Stato',
    'admin.newsCreateSuccess': 'Articolo creato con successo',
    'admin.newsUpdateSuccess': 'Articolo aggiornato con successo',
    'admin.newsDeleteSuccess': 'Articolo eliminato con successo',

    // Invitation code management
    'admin.invitationManagement': 'Gestione Codici Invito',
    'admin.createInvitation': 'Crea Invito',
    'admin.invitationCode': 'Codice Invito',
    'admin.invitationCreated': 'Invito creato con successo',
    'admin.copy': 'Copia',
    'admin.codeCopied': 'Codice copiato negli appunti',
    'admin.noInvitations': 'Nessun invito trovato',

    // Authorization request related
    'user.authRequests': 'Richieste Autorizzazione',
    'user.authRequestManagement': 'Gestione Richieste Autorizzazione',
    'user.createAuthRequest': 'Crea Richiesta Autorizzazione',
    'user.authCode': 'Codice Autorizzazione',
    'user.authRequestCreated': 'Richiesta autorizzazione creata',
    'user.shareAuthLink': 'Condividi Link Autorizzazione',
    'user.shareAuthLinkHelp': 'Invia questo link a un admin per autorizzarlo a gestire il tuo account',
    'user.linkCopied': 'Link copiato negli appunti',
    'user.copyLink': 'Copia Link',
    'user.share': 'Condividi',
    'user.shareLink': 'Condividi Link',
    'user.authRequestHelp': 'Crea una richiesta di autorizzazione per consentire a un admin di gestire il tuo account',
    'user.authRequestShareTitle': 'Autorizzazione Gestione Batteria IoT',
    'user.authRequestShareText': 'Ti autorizzo come admin del mio sistema batteria',
    'common.noAuthRequests': 'Nessuna richiesta di autorizzazione trovata',
    'user.pending': 'In Attesa',
    'user.accepted': 'Accettata',
    'user.rejected': 'Rifiutata',

    'admin.authRequestReview': 'Revisione Richiesta Autorizzazione',
    'admin.authRequestDetails': 'Dettagli Richiesta Autorizzazione',
    'admin.authRequestLoadError': 'Errore caricamento richieste autorizzazione',
    'admin.requestCode': 'Codice Richiesta',
    'admin.createdBy': 'Creato Da',
    'admin.processedBy': 'Elaborato Da',
    'admin.processedAt': 'Elaborato Il',
    'admin.unknownUser': 'Utente Sconosciuto',
    'admin.accept': 'Accetta',
    'admin.reject': 'Rifiuta',
    'admin.authRequestAccepted': 'Richiesta autorizzazione accettata',
    'admin.authRequestRejected': 'Richiesta autorizzazione rifiutata',
    'admin.authRequestNotForAdmin': 'La gestione delle richieste di autorizzazione è applicabile solo agli utenti normali. Come admin, puoi rivedere ed elaborare le richieste di autorizzazione degli utenti.',

    // Battery pack details
    'battery.packageDetails': 'Dettagli Pacco Batteria',

    'battery.basicInfo': 'Informazioni di Base',
    'battery.cellCount': 'Numero Celle',
    'battery.tempSensorCount': 'Numero Sensori Temp.',
    'battery.chargeCurrentStatus': 'Stato Corrente Carica',
    'battery.totalVoltageStatus': 'Stato Voltaggio Totale',
    'battery.dischargeCurrentStatus': 'Stato Corrente Scarica',
    'battery.controlStatus': 'Stato Controllo e Comando',
    'battery.instructionState': 'Stato Istruzione',
    'battery.controlState': 'Stato Controllo',
    'battery.chargerAvailable': 'Caricabatterie Disponibile',
    'battery.warningStatus': 'Stato Avvisi e Guasti',
    'battery.led_warning': 'Avviso LED',
    'battery.buzzer_warning': 'Avviso Cicalino',
    'battery.freq_shift': 'Spostamento Frequenza',
    'battery.parallelStatus': 'Stato Sistema Batterie Parallele',
    'battery.parallelCount': 'Numero Batterie Parallele',
    'battery.avgCycleCount': 'Cicli Medi di Carica',
    'battery.cycleCountUnit': 'cicli',


    'battery.standby': 'Standby',
    'battery.cellVoltage': 'Voltaggio Cella',
    'battery.batteryPackUnavailable': 'Dati pacco batteria temporaneamente non disponibili, tentativo di visualizzazione dati precedenti...',
    'battery.normalStatus': 'Questo pacco batteria è normale, nessun avviso o guasto',
    'battery.warn_high_charge_temp': 'Alta Temperatura Carica',

    // Dashboard new content
    'dashboard.soc': 'SOC',
    'dashboard.voltage': 'Voltaggio Totale',
    'dashboard.current': 'Corrente Totale',
    'dashboard.temperature': 'Temperatura Max',
    'dashboard.systemStatus': 'Stato Sistema',
    'dashboard.totalDevices': 'Dispositivi Totali',
    'dashboard.onlineDevices': 'Dispositivi Online',
    'dashboard.deviceStatus': 'Stato Dispositivo',
    'dashboard.batteryStatus': 'Stato Batteria',
    'dashboard.powerStatus': 'Stato Potenza',
    'dashboard.temperatureStatus': 'Stato Temperatura',
    'dashboard.avgSOC': 'SOC Medio',
    'dashboard.types': 'Tipi',
    'dashboard.batteryHistory': 'Dati Storici Batteria',
    'dashboard.voltageHistory': 'Storico Voltaggio',
    'dashboard.currentHistory': 'Storico Corrente',
    'dashboard.socHistory': 'Storico SOC',
    'dashboard.temperatureHistory': 'Storico Temperatura',
    'dashboard.lastHour': 'Ultima Ora',
    'dashboard.last6Hours': 'Ultime 6 Ore',
    'dashboard.lastDay': 'Ultime 24 Ore',
    'dashboard.lastWeek': 'Ultima Settimana',
    'dashboard.lastMonth': 'Ultimo Mese',
    'dashboard.batteryDetails': 'Dettagli Batteria',
    'dashboard.deviceAnalysis': 'Analisi Dispositivo',
    'dashboard.systemOverview': 'Panoramica Sistema',
    'dashboard.deviceTypeDistribution': 'Distribuzione Tipi Dispositivo',
    'dashboard.voltageAndCurrentOverview': 'Panoramica Voltaggio e Corrente',
    'dashboard.onlinePercentage': 'Percentuale Online',
    'dashboard.noAlerts': 'Nessun record di allarme',

    // Dashboard page specific
    'dashboard.totalInstallations': 'Impianti Totali',
    'dashboard.viewAllInstallations': 'Vedi Tutti gli Impianti',
    'dashboard.activeInstallations': 'Impianti Attivi',
    'dashboard.allInstallations': 'Tutti gli Impianti',
    'dashboard.systemAlertsNotices': 'Allarmi e Notifiche Sistema',
    'dashboard.deviceOffline': 'Dispositivo Offline',
    'dashboard.deviceOfflineDesc': 'Il dispositivo {{name}} ({{id}}) è attualmente offline. Controllare la connessione.',
    'dashboard.deviceAlarm': 'Allarme Dispositivo',
    'dashboard.deviceAlarmDesc': 'Il dispositivo {{name}} ({{id}}) ha allarmi attivi. Controllare lo stato del dispositivo.',
    'dashboard.systemNormal': 'Sistema Normale',
    'dashboard.systemNormalDesc': 'Tutti i sistemi funzionano normalmente.',
    'dashboard.latestNews': 'Novità Prodotto',

    // InstallationList page
    'installations.loadError': 'Errore caricamento impianti. Riprova più tardi.',
    'installations.noInstallations': 'Nessun impianto trovato.',
    'installations.realtime': 'Real-time',
    'installations.oldData': 'Dati Precedenti',
    'installations.batteries': 'Batterie',
    'installations.lastUpdate': 'Ultimo Aggiornamento',
    'installations.deviceName': 'Nome Impianto (opzionale)',
    'installations.deviceNamePlaceholder': 'Il Mio Sistema Batteria',
    'installations.deviceNameHelper': 'Assegna un nome descrittivo al dispositivo',
    'installations.deviceIdRequired': 'ID dispositivo richiesto',
    'installations.deviceIdPlaceholder': 'ID su etichetta WIFI',
    'installations.deviceClaimed': 'Dispositivo aggiunto con successo',
    'installations.addFailed': 'Errore aggiunta dispositivo',
    'installations.otherType': 'Altro',


    // Installation Detail page
    'detail.backToList': 'Torna alla Lista',
    'detail.installationDetail': 'Dettagli Impianto',
    'detail.installationName': 'Nome Impianto',
    'detail.owner': 'Proprietario',
    'detail.batteryCount': 'Numero Batterie',
    'detail.realtimeMetrics': 'Metriche Real-time',
    'detail.avgSOC': 'SOC Medio',
    'detail.avgSOH': 'SOH Medio',
    'detail.maxCellVol': 'Voltaggio Max Cella',
    'detail.minCellVol': 'Voltaggio Min Cella',
    'detail.cellVolDiff': 'Differenza Voltaggio Celle',

    // Battery Detail page
    'battery.packDetail': 'Dettagli Pacco Batteria #{{index}}',

    'battery.packNotFound': 'Dati pacco batteria non trovati',
    'battery.loadError': 'Errore caricamento dati batteria',

    // Battery Overview
    'battery.packVoltage': 'Voltaggio Pacco Batteria',
    'battery.packCurrent': 'Corrente Pacco Batteria',
    'battery.packPower': 'Potenza Pacco Batteria',
    'battery.chargerConnected': 'Caricabatterie Collegato',
    'battery.fullEnergy': 'Energia Totale',
    'battery.remainEnergy': 'Energia Residua',

    'common.yes': 'Sì',
    'common.no': 'No',
    'common.on': 'Acceso',
    'common.off': 'Spento',
    'common.ongoing': 'In Corso',


    // RealTime Monitor
    'battery.cellVoltages': 'Voltaggi Celle',
    'battery.temperatures': 'Monitoraggio Temperatura',

    // History Charts
    'battery.historyTrends': 'Tendenze Storiche',
    'battery.voltageCurrent': 'Voltaggio e Corrente',

    'battery.dragToSelect': 'Trascina per selezionare intervallo temporale',

    'battery.alarmDetails': 'Dettagli Allarme',
    'battery.noActiveAlarms': 'Nessun allarme attivo',
    'battery.sensor': 'Sensore',
    'battery.issue': 'Problema',
    'battery.tempSensorIssues': 'Problemi Sensori Temperatura',

    // Charts & Widgets
    'battery.minCellVoltage': 'Voltaggio Min Cella',
    'battery.maxCellVoltage': 'Voltaggio Max Cella',


    'battery.mosTemp': 'Temperatura MOS',
    'battery.envTemp': 'Temperatura Ambiente',
    'battery.otherTemps': 'Altre Temperature',


    'battery.noDataAvailable': 'Nessun dato disponibile',
    'battery.fetchError': 'Errore recupero dati storici',
    'battery.generalError': 'Si è verificato un errore',

    // Settings - Common
    'settings.recover': 'Recupero',
    'settings.delay': 'Ritardo',
    'settings.unitV': 'Unità: V',
    'settings.unitA': 'Unità: A',
    'settings.unitMs': 'Unità: ms',
    'settings.unitUs': 'Unità: μs',
    'settings.unitC': 'Unità: °C',
    'settings.charge': 'Carica',
    'settings.discharge': 'Scarica',
    'settings.high': 'Alto',
    'settings.low': 'Basso',
    'settings.description': 'Descrizione',
    'settings.read': 'Leggi',
    'settings.setting': 'Impostazione...',
    'settings.readSuccess': 'Lettura riuscita',
    'settings.timeout': 'Timeout operazione',
    'settings.operationFailed': 'Operazione fallita',
    'settings.failed': 'Fallito',
    'settings.jkReadOnlyNote': 'Le impostazioni JK BMS vengono aggiornate automaticamente tramite broadcast e sono in sola lettura in questo sistema.',
    'settings.lastUpdated': 'Ultimo aggiornamento',
    'settings.chargeHighTemp': 'Alta temp. di carica',
    'settings.dischargeHighTemp': 'Alta temp. di scarica',
    'settings.designCapacity': 'Capacità nominale',
    'settings.balanceMaxCurrent': 'Corrente bilanciam. max',
    'settings.balanceTriggerDiff': 'Diff. bilanciamento',

    // Settings - Control Tab
    'settings.mosControl': 'Controllo MOS',
    'settings.chargeMosControl': 'Controllo MOS Carica',
    'settings.openChargeMos': 'Apri MOS Carica',
    'settings.closeChargeMos': 'Chiudi MOS Carica',
    'settings.dischargeMosControl': 'Controllo MOS Scarica',
    'settings.openDischargeMos': 'Apri MOS Scarica',
    'settings.closeDischargeMos': 'Chiudi MOS Scarica',
    'settings.powerManagement': 'Gestione Alimentazione',
    'settings.shutdownSleep': 'Spegnimento/Sleep',
    'settings.opening': 'Apertura...',
    'settings.closing': 'Chiusura...',
    'settings.executing': 'Esecuzione...',

    // Settings - Protection Tab
    'settings.protGroup1': 'Parametri Protezione Voltaggio',
    'settings.cellOvercharge': 'Sovracarica Cella',
    'settings.cellOverchargeDesc': 'Quando il voltaggio della cella supera continuamente il valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica. Dopo l\'attivazione della protezione, quando tutti i voltaggi delle celle scendono al di sotto del valore di recupero, il sistema ripristina la funzione di carica.',
    'settings.cellOverdischarge': 'Scarica Eccessiva Cella',
    'settings.cellOverdischargeDesc': 'Quando il voltaggio della cella scende continuamente al di sotto del valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la scarica. Dopo l\'attivazione della protezione, quando tutti i voltaggi delle celle salgono al di sopra del valore di recupero, il sistema ripristina la funzione di scarica.',
    'settings.totalOvercharge': 'Sovracarica Totale',
    'settings.totalOverchargeDesc': 'Quando il voltaggio totale supera continuamente il valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica. Dopo l\'attivazione della protezione, quando tutti i voltaggi delle celle scendono al di sotto del valore di recupero, il sistema ripristina la funzione di carica.',
    'settings.totalOverdischarge': 'Scarica Eccessiva Totale',
    'settings.totalOverdischargeDesc': 'Quando il voltaggio totale scende continuamente al di sotto del valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la scarica. Dopo l\'attivazione della protezione, quando tutti i voltaggi delle celle salgono al di sopra del valore di recupero, il sistema ripristina la funzione di scarica.',

    'settings.protGroup2': 'Parametri Protezione Corrente',
    'settings.chargeOvercurrent': 'Sovracorrente Carica',
    'settings.chargeOvercurrentDesc': 'Il valore di avviso è la corrente di carica massima richiesta all\'inverter. Quando la corrente di carica supera continuamente il valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica.',
    'settings.dischargeOvercurrent1': 'Sovracorrente Scarica 1',
    'settings.dischargeOvercurrent1Desc': 'Il valore di avviso è la corrente di scarica massima richiesta all\'inverter. Quando la corrente di scarica supera continuamente il valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la scarica.',
    'settings.dischargeOvercurrent2': 'Sovracorrente Scarica 2',
    'settings.dischargeOvercurrent2Desc': 'Quando la corrente di scarica supera continuamente il valore di protezione per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la scarica.',
    'settings.maxChargeCurrent': 'Limite Corrente Carica',
    'settings.maxChargeCurrentDesc': 'Il Limite Corrente Carica (CCL) si riferisce alla corrente di carica massima consentita che un singolo modulo batteria segnala all\'inverter in condizioni normali di funzionamento. Quando N moduli batteria sono collegati in parallelo, la corrente di carica massima totale richiesta dal sistema batteria all\'inverter è la somma dei CCL individuali, cioè CCL × N. \nIl valore di protezione si riferisce alla soglia di corrente alla quale un singolo modulo batteria attiva la protezione da sovracorrente. Il CCL deve essere impostato inferiore al valore di protezione.',
    'settings.maxDischargeCurrent': 'Limite Corrente Scarica',
    'settings.maxDischargeCurrentDesc': 'Il Limite Corrente Scarica (DCL) si riferisce alla corrente di scarica massima consentita che un singolo modulo batteria segnala all\'inverter in condizioni normali di funzionamento. Quando N moduli batteria sono collegati in parallelo, la corrente di scarica massima totale richiesta dal sistema batteria all\'inverter è la somma dei DCL individuali, cioè DCL × N. \nIl valore di protezione si riferisce alla soglia di corrente alla quale un singolo modulo batteria attiva la protezione da sovracorrente. Il DCL deve essere impostato inferiore al valore di protezione.',
    'settings.maxChargeVoltage': 'Limite Voltaggio Carica',
    'settings.maxChargeVoltageDesc': 'Il Limite Voltaggio Carica (CVL) è il voltaggio totale massimo richiesto dal sistema batteria all\'inverter.',
    'settings.chargeVoltageLimitV': 'CVL (V)',
    'settings.chargeCurrentLimitA': 'CCL (A)',
    'settings.dischargeCurrentLimitA': 'DCL (A)',
    'settings.shortCircuitDesc': 'Quando viene rilevato un cortocircuito per il ritardo impostato, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica e la scarica.',

    'settings.protGroup3': 'Parametri Protezione Temperatura',
    'settings.tempHigh': 'Protezione Alta Temperatura',
    'settings.tempHighDesc': 'Quando la temperatura supera il valore di protezione, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica o la scarica. Dopo l\'attivazione della protezione, quando la temperatura scende al di sotto del valore di recupero, il sistema ripristina la funzione di carica o scarica.',
    'settings.tempLow': 'Protezione Bassa Temperatura',
    'settings.tempLowDesc': 'Quando la temperatura scende al di sotto del valore di protezione, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica o la scarica. Dopo l\'attivazione della protezione, quando la temperatura sale al di sopra del valore di recupero, il sistema ripristina la funzione di carica o scarica. Quando la temperatura scende al di sotto del valore di avviso di carica, la funzione di riscaldamento si attiva automaticamente. Quando la temperatura sale al valore di recupero di carica, la funzione di riscaldamento si spegne automaticamente.',
    'settings.mosTempHigh': 'Protezione Alta Temperatura MOS',
    'settings.mosTempHighDesc': 'Quando la temperatura del MOS è superiore al valore di protezione, il BMS esegue immediatamente l\'azione di protezione e interrompe forzatamente la carica e la scarica. Dopo l\'attivazione della protezione, quando la temperatura del MOS scende al di sotto del valore di recupero, il sistema ripristina la funzione di carica o scarica.',
    'settings.envTemp': 'Protezione Temperatura Ambiente',
    'settings.envTempDesc': 'Quando la temperatura ambiente supera il valore di protezione alta temperatura o scende al di sotto del valore di protezione bassa temperatura, il BMS eseguirà immediatamente l\'azione di protezione e interromperà forzatamente la carica o la scarica. Dopo l\'attivazione della protezione, quando la temperatura ambiente torna all\'intervallo di temperatura di recupero corrispondente, il sistema ripristinerà automaticamente la funzione di carica o scarica.',

    'settings.enableProtection': 'Abilita Protezione',
    'settings.chargeTempProt': 'Protezione Temp. Carica',
    'settings.dischargeTempProt': 'Protezione Temp. Scarica',

    // Settings - History Tab
    'settings.historyManagement': 'Gestione Record Storici',
    'settings.reading': 'Lettura...',
    'settings.readHistory': 'Leggi tutti i record storici (1-40)',
    'settings.stopReading': 'Ferma Lettura',
    'settings.clearHistory': 'Cancella Record Storici',
    'settings.messages.historyReadComplete': 'Lettura record storici completata! Totale {{count}} record letti',
    'settings.historyRecords': 'Record Storici ({{count}} record)',
    'settings.record': 'Record {{index}}',
    'settings.timeUnknown': 'Orario Sconosciuto',
    'settings.cellInfo': 'Informazioni Celle ({{count}} celle)',
    'settings.tempSensors': 'Sensori Temperatura ({{count}} sensori)',
    'settings.statusInfo': 'Informazioni Stato',
    'settings.noHistoryFound': 'Nessun record storico trovato',
    'settings.clearHistoryResult': 'Risultato cancellazione record storici',
    'settings.confirmClearHistory': 'Conferma Cancellazione Storico',
    'settings.confirmClearHistoryDesc': 'Sei sicuro di voler eliminare tutti i record storici dal BMS?',
    'settings.clearHistoryWarning': 'Questa operazione eliminerà permanentemente tutti i dati dei record storici dal dispositivo BMS e non potrà essere recuperata.',
    'settings.confirmDelete': 'Conferma Eliminazione',

    // Settings - Protocol Tab
    'settings.inverterProtocolConfig': 'Configurazione Protocollo Inverter',
    'settings.protocolSelectDesc': 'Dopo aver letto l\'elenco dei protocolli inverter, seleziona il protocollo inverter che stai utilizzando dal menu a discesa.',



    'settings.canProtocol': 'Protocollo CAN',
    'settings.rs485Protocol': 'Protocollo RS485',
    'settings.selectCanProtocol': 'Seleziona Protocollo CAN',
    'settings.selectRs485Protocol': 'Seleziona Protocollo RS485',

    // Settings - System Tab
    'settings.mainBatterySettings': 'Impostazioni Pacco Principale',
    'settings.systemConfig': 'Configurazione Batteria',
    'settings.otherConfig': 'Altre Impostazioni',
    'settings.timeSettings': 'Impostazioni Orario',
    'settings.timeSettingsDesc': 'Orario interno BMS, utilizzato per la visualizzazione e la registrazione dei dati. La sincronizzazione con l\'orario locale rende più facile il tracciamento dei dati.',
    'settings.syncTime': 'Sincronizza Orario Locale',
    'settings.bmsTime': 'Orario BMS',
    'settings.capacitySettings': 'Impostazioni Capacità',
    'settings.capacitySettingsDesc': 'La modifica dell\'impostazione della capacità residua influisce sulla visualizzazione della percentuale SOC. La capacità nominale è la capacità nominale della batteria in fabbrica, e la capacità di carica completa indica la capacità attuale reale della batteria, che diminuisce con il tempo di utilizzo e il numero di cicli.',
    'settings.batterySeries': 'Impostazioni Conteggio Serie',
    'settings.batterySeriesDesc': 'Il conteggio serie celle predefinito del sistema è 16. Quando il conteggio serie celle effettivo è inferiore a 16, regolalo qui al valore effettivo corrispondente.',
    'settings.batterySeriesHelper': 'Conteggio celle in serie',
    'settings.cycleCount': 'Impostazioni Conteggio Cicli',
    'settings.cycleCountDesc': 'Il conteggio cicli si accumula automaticamente durante il processo di carica/scarica della batteria e supporta la regolazione manuale qui.',
    'settings.cycleCountHelper': 'Conteggio cicli carica/scarica batteria',
    'settings.fullChargeParams': 'Parametri Carica Completa',
    'settings.fullChargeParamsDesc': 'Imposta le condizioni di determinazione della carica completa. Quando il voltaggio e la corrente della batteria soddisfano simultaneamente le condizioni di cutoff, il BMS determina che la batteria è completamente carica. L\'allarme bassa capacità viene utilizzato per impostare la soglia di avviso batteria scarica SOC.',
    'settings.fullChargeCutoffVoltage': 'Voltaggio Cutoff Carica Completa (V)',
    'settings.fullChargeCutoffCurrent': 'Corrente Cutoff Carica Completa (A)',
    'settings.lowCapacityAlarm': 'Allarme Bassa Capacità (%)',
    'settings.capacityRelease': 'Impostazioni Rilascio Capacità',
    'settings.capacityReleaseDesc': 'Imposta Comando (Set): A5\nImposta la soglia SOC per il rilascio della capacità.',
    'settings.socValue': 'Valore SOC (%)',
    'settings.socRange': 'Intervallo: 74-97',
    'settings.currentZero': 'Calibrazione Zero Corrente',
    'settings.currentZeroDesc': 'Comando: AA\nCalibra il punto zero del sensore di corrente quando non c\'è corrente. Puoi inserire il valore di correzione (default è 0).',
    'settings.correctionValue': 'Valore Correzione (0.1A)',
    'settings.refVoltage': 'Calibrazione Voltaggio Riferimento',
    'settings.refVoltageDesc': 'Comando: A9\nCalibra il voltaggio di riferimento del pacco batteria (solitamente si riferisce al riferimento di campionamento del voltaggio della cella). Inserisci il valore di voltaggio effettivo misurato (mV).',
    'settings.actualVoltageMv': 'Voltaggio Effettivo (mV)',
    'settings.totalVoltage': 'Calibrazione Voltaggio Totale',
    'settings.totalVoltageDesc': 'Inserisci qui il voltaggio effettivo della batteria misurato con multimetro o altro equipaggiamento di misura, che può essere utilizzato per calibrare il valore di voltaggio visualizzato dal BMS.',
    'settings.actualTotalVoltageMv': 'Voltaggio Totale Effettivo (mV)',
    'settings.chargeCurrent': 'Calibrazione Corrente Carica',
    'settings.chargeCurrentDesc': 'Comando: AC\nCalibra la corrente di carica. Inserisci il valore effettivo della corrente di carica misurata (A). Il sistema convertirà automaticamente in unità 0.1A.',
    'settings.actualCurrentA': 'Corrente Effettiva (A)',
    'settings.dischargeCurrent': 'Calibrazione Corrente Scarica',
    'settings.dischargeCurrentDesc': 'Comando: AB\nCalibra la corrente di scarica. Inserisci il valore effettivo della corrente di scarica misurata (A). Il sistema convertirà automaticamente in unità 0.1A.',
    'settings.systemInfo': 'Informazioni Sistema',
    'settings.versionInfo': 'Informazioni Versione',
    'settings.versionInfoDesc': 'Versione firmware BMS.',
    'settings.internalVersion': 'Versione Firmware',
    'settings.internalVersionHelper': 'Informazioni versione interna',
    'settings.restoreDefault': 'Ripristina Default',
    'settings.restoreDefaultDesc': 'Questa operazione ripristinerà tutti i parametri ai valori predefiniti di fabbrica del BMS.',
    'settings.restoreDefaultBtn': 'Ripristina Parametri Default',
    'settings.restoring': 'Ripristino...',

    // Settings - Permissions Tab
    'settings.permissionsDesc': 'Concedi ad altri utenti il permesso di visualizzare o controllare questo impianto.',
    'settings.shareSuccess': 'Condiviso con successo con {{email}}',
    'settings.shareFailed': 'Condivisione impianto fallita',
    'settings.removeAccessSuccess': 'Rimozione permesso riuscita',
    'settings.removeAccessFailed': 'Rimozione permesso fallita',
    'settings.loadingUsers': 'Caricamento utenti...',
    'settings.noSharedUsers': 'Nessun utente ha ancora accesso.',
    'settings.noPermission': 'Non hai il permesso di gestire questo impianto. Solo il proprietario può condividere l\'impianto.',
    'settings.userEmail': 'Email Utente',
    'settings.accessLevel': 'Livello Accesso',
    'settings.readOnly': 'Solo Lettura',
    'settings.readWrite': 'Lettura/Scrittura',
    'settings.sharing': 'Condivisione...',
    'settings.shareDevice': 'Condividi Impianto',
    'settings.usersWithAccess': 'Utenti con Accesso',
    'settings.remove': 'Rimuovi',

    // Settings - SettingsLogTab
    'settings.modificationLog': 'Log Modifiche Impostazioni',
    'settings.loadHistoryFailed': 'Errore caricamento record storici',
    'settings.noChangesFound': 'Nessuna modifica trovata',
    'settings.logSetting': 'Elemento Impostazione',
    'settings.na': 'N/D',

    // Settings - Params Mapping (Log Types)
    'settings.enabled': 'Abilitato',
    'settings.controlMode': 'Modalità Controllo',
    'settings.delayMs': 'Ritardo (ms)',
    'settings.unknown': 'Sconosciuto',
    'settings.alarmVoltage': 'Allarme (mV)',
    'settings.chargeAlarmVoltage': 'Allarme Carica (mV)',
    'settings.dischargeAlarmVoltage': 'Allarme Scarica (mV)',
    'settings.protectionVoltage': 'Protezione (mV)',
    'settings.recoveryVoltage': 'Recupero (mV)',
    'settings.alarmVoltageV': 'Allarme (V)',
    'settings.protectionVoltageV': 'Protezione (V)',
    'settings.recoveryVoltageV': 'Recupero (V)',
    'settings.alarmCurrentA': 'Allarme (A)',
    'settings.protectionCurrentA': 'Protezione (A)',
    'settings.recoveryCurrentA': 'Recupero (A)',
    'settings.chargeProtectionCurrentA': 'Protezione Carica (A)',
    'settings.delayUs': 'Ritardo (μs)',
    'settings.alarmCurrentMa': 'Allarme (mA)',
    'settings.protectionCurrentMa': 'Protezione (mA)',
    'settings.recoveryCurrentMa': 'Recupero (mA)',
    'settings.alarmTemp': 'Allarme (°C)',
    'settings.protectionTemp': 'Protezione (°C)',
    'settings.recoveryTemp': 'Recupero (°C)',
    'settings.chargeHighTempAlarm': 'Allarme Alta Temp. Carica (°C)',
    'settings.chargeHighTempProtection': 'Protezione Alta Temp. Carica (°C)',
    'settings.chargeHighTempRecovery': 'Recupero Alta Temp. Carica (°C)',
    'settings.dischargeHighTempAlarm': 'Allarme Alta Temp. Scarica (°C)',
    'settings.dischargeHighTempProtection': 'Protezione Alta Temp. Scarica (°C)',
    'settings.dischargeHighTempRecovery': 'Recupero Alta Temp. Scarica (°C)',
    'settings.chargeLowTempAlarm': 'Allarme Bassa Temp. Carica (°C)',
    'settings.chargeLowTempProtection': 'Protezione Bassa Temp. Carica (°C)',
    'settings.chargeLowTempRecovery': 'Recupero Bassa Temp. Carica (°C)',
    'settings.dischargeLowTempAlarm': 'Allarme Bassa Temp. Scarica (°C)',
    'settings.dischargeLowTempProtection': 'Protezione Bassa Temp. Scarica (°C)',
    'settings.dischargeLowTempRecovery': 'Recupero Bassa Temp. Scarica (°C)',
    'settings.envHighTempAlarm': 'Allarme Alta Temp. Ambiente (°C)',
    'settings.envHighTempProtection': 'Protezione Alta Temp. Ambiente (°C)',
    'settings.envHighTempRecovery': 'Recupero Alta Temp. Ambiente (°C)',
    'settings.envLowTempAlarm': 'Allarme Bassa Temp. Ambiente (°C)',
    'settings.envLowTempProtection': 'Protezione Bassa Temp. Ambiente (°C)',
    'settings.envLowTempRecovery': 'Recupero Bassa Temp. Ambiente (°C)',
    'settings.socPercent': 'SOC (%)',
    'settings.sleepVoltageMv': 'Voltaggio Sleep (mV)',
    'settings.sleepDelayMin': 'Ritardo Sleep (min)',
    'settings.chargeDelayMs': 'Ritardo Carica (ms)',
    'settings.chargeProtectionCurrentMa': 'Corrente Protezione Carica (mA)',
    'settings.dischargeDelayMs': 'Ritardo Scarica (ms)',

    // Balance Settings
    'settings.balance': 'Impostazioni Bilanciamento Attivo',
    'settings.balanceDesc': 'Imposta il voltaggio di avvio per il bilanciamento attivo. Il bilanciamento attivo si attiva quando il voltaggio della cella è maggiore del voltaggio di avvio e si spegne quando è inferiore.',
    'settings.balanceStartVoltage': 'Voltaggio Avvio',
    'settings.balanceStartDiff': 'Differenza Avvio',
    'settings.balanceStartVoltageMv': 'Voltaggio Avvio (mV)',
    'settings.balanceStartDiffMv': 'Diff. Avvio (mV)',

    // JK BMS Impostazioni - Protezione tensione pacco
    'jk.noSettingsData': 'Nessun dato di impostazione ricevuto. Le impostazioni vengono aggiornate quando il BMS trasmette un frame SETUP.',
    'jk.chargeVoltages': 'Tensioni di Carica',
    'jk.socSettings': 'Impostazioni SOC',
    'jk.packVoltageProtection': 'Protezione tensione pacco',
    'jk.packOVP': 'Tensione di Mantenimento',
    'jk.packUVP': 'Tensione Max di Carica Inverter',
    'jk.floatVoltage': 'Tensione di Mantenimento',
    'jk.inverterMaxChargeVoltage': 'Tensione Max di Carica Inverter',
    'jk.soc100Voltage': 'Tensione SOC 100%',
    'jk.soc0Voltage': 'Tensione SOC 0%',
    'jk.smartSleepVoltage': 'Tensione sleep intelligente',
    'jk.autoPowerOffVoltage': 'Tensione spegnimento auto.',
    // JK BMS Impostazioni - Protezione corrente
    'jk.currentProtection': 'Protezione corrente',
    'jk.chargeOC': 'Limite corrente carica',
    'jk.chargeOCPDelay': 'Ritardo OCP carica',
    'jk.chargeOCPRelease': 'Rilascio OCP carica',
    'jk.dischargeOC': 'Limite corrente scarica',
    'jk.dischargeOCPDelay': 'Ritardo OCP scarica',
    'jk.dischargeOCPRelease': 'Rilascio OCP scarica',
    'jk.scpRelease': 'Rilascio SCP',
    // JK BMS Impostazioni - Configurazione batteria
    'jk.batteryConfig': 'Configurazione batteria',
    'jk.cellCount': 'Numero celle',
    'jk.chargeSwitch': 'Interruttore carica',
    'jk.dischargeSwitch': 'Interruttore scarica',
    'jk.balanceSwitch': 'Interruttore bilanciamento',
    'jk.scpDelay': 'Ritardo SCP',
    // JK BMS Impostazioni - Configurazione dispositivo
    'jk.deviceConfig': 'Configurazione dispositivo',
    'jk.deviceAddress': 'Indirizzo dispositivo',
    'jk.prechargeDelay': 'Ritardo precarica',
    'jk.smartSleepTime': 'Tempo sleep intelligente',
    'jk.heatEnabled': 'Riscaldamento',
    'jk.tempSensorDisabled': 'Sensore temp. disabilitato',
    'jk.gpsHeartbeat': 'Heartbeat GPS',
    'jk.portSwitch': 'Porta (RS485)',
    'jk.lcdAlwaysOn': 'LCD sempre acceso',
    'jk.specialCharger': 'Caricatore speciale',
    'jk.smartSleepEnabled': 'Sleep intelligente',
    'jk.disablePCLModule': 'Disabilita modulo PCL',
    'jk.timedStoredData': 'Memorizzazione dati temp.',
    'jk.chargingFloatMode': 'Modalità carica float',

    // Setting Types













    'settings.fullCharge': 'Impostazioni Carica Completa',
    'settings.cellSleep': 'Sleep Cella',
    'settings.cellSleepDesc': 'Quando il voltaggio della cella scende al di sotto del voltaggio di sleep per più tempo del ritardo, la batteria entrerà in modalità sleep per risparmiare energia.',
    'settings.inverterProtocol': 'Protocollo Inverter',

    // InstallationSettings Main Page
    'settings.title': 'Impostazioni Impianto',

    'settings.sendCommandFailed': 'Invio comando fallito',
    'settings.confirmShutdown': 'Conferma Spegnimento/Sleep',
    'settings.confirmShutdownDesc': 'Sei sicuro di voler spegnere o mettere in sleep la batteria? Dopo lo spegnimento, dovrai andare sul sito dell\'impianto batteria per avviarla manualmente.',

    // Tabs
    'settings.tabs.control': 'Controllo',
    'settings.tabs.protection': 'Impostazioni Protezione',
    'settings.tabs.protocol': 'Impostazioni Protocollo',
    'settings.tabs.system': 'Impostazioni Sistema',
    'settings.tabs.log': 'Log Impostazioni',

    // Messages
    'settings.messages.fetchingProtocolSettings': 'Recupero impostazioni protocollo...',
    'settings.messages.fetchProtocolListFailed': 'Errore recupero elenco protocolli inverter',
    'settings.messages.fetchingHistory': 'Lettura record storici...',
    'settings.messages.startReadingHistory': 'Avvio lettura record storici...',
    'settings.messages.readingHistoryProgress': 'Lettura record {{current}}/{{total}}...',
    'settings.messages.protocolSetSuccess': 'Protocollo impostato con successo',
    'settings.messages.protocolListSuccess': 'Elenco protocolli recuperato con successo',
    'settings.messages.protocolListComplete': 'Recupero elenco protocolli completato! Trovati {{count}} protocolli',
    'settings.messages.protocolListCompleteCan': 'Recupero elenco protocolli completato! Trovati {{count}} protocolli CAN',
    'settings.messages.fetchingProtocolIds': 'Recupero elenco ID protocollo...',
    'settings.messages.fetchingCanNames': 'Recupero nomi protocolli CAN...',
    'settings.messages.fetchingRs485Names': 'Recupero nomi protocolli RS485...',



    // Support System
    'support.title': 'Supporto Tecnico',
    'support.newPost': 'Nuovo Post',
    'support.editPost': 'Modifica Post',
    'support.searchPlaceholder': 'Cerca post...',
    'support.filterByTag': 'Filtra per Tag',
    'support.allTags': 'Tutti i Tag',
    'support.products': 'Prodotti',
    'support.categories': 'Categorie',
    'support.sortBy': 'Ordina Per',
    'support.sortLatest': 'Più Recenti',
    'support.sortPopular': 'Popolari',
    'support.sortUnsolved': 'Non Risolti',
    'support.sortMostViewed': 'Più Visti',
    'support.loadError': 'Errore caricamento post',
    'support.noSearchResults': 'Nessun post trovato',
    'support.noPosts': 'Nessun post ancora',
    'support.createFirstPost': 'Crea primo post',
    'support.minutesAgo': '{{count}} minuti fa',
    'support.hoursAgo': '{{count}} ore fa',
    'support.daysAgo': '{{count}} giorni fa',
    'support.pinned': 'In Evidenza',
    'support.locked': 'Bloccato',
    'support.resolved': 'Risolto',
    'support.private': 'Privato',
    'support.views': 'Visualizzazioni',
    'support.replies': 'Risposte',
    'support.noReplies': 'Nessuna risposta ancora',
    'support.backToList': 'Torna alla Lista',
    'support.postNotFound': 'Post non trovato',
    'support.accessDenied': 'Accesso negato',
    'support.addReply': 'Aggiungi Risposta',
    'support.replyPlaceholder': 'Inserisci la tua risposta...',
    'support.submitReply': 'Invia Risposta',
    'support.loginToReply': 'Accedi per rispondere',
    'support.postLocked': 'Post bloccato, impossibile rispondere',
    'support.bestAnswer': 'Migliore Risposta',
    'support.markBestAnswer': 'Segna come Migliore',
    'support.unmarkBestAnswer': 'Rimuovi Migliore',
    'support.confirmDelete': 'Conferma Eliminazione',
    'support.confirmDeletePost': 'Eliminare questo post?',
    'support.confirmDeleteReply': 'Eliminare questa risposta?',
    'support.pin': 'Metti in Evidenza',
    'support.unpin': 'Rimuovi Evidenza',
    'support.lock': 'Blocca',
    'support.unlock': 'Sblocca',
    'support.statusOpen': 'Non Risolto',
    'support.statusResolved': 'Risolto',
    'support.statusClosed': 'Chiuso',
    'support.postTitle': 'Titolo Post',
    'support.titlePlaceholder': 'Descrivi brevemente il tuo problema',
    'support.postContent': 'Contenuto',
    'support.contentPlaceholder': 'Descrivi in dettaglio il tuo problema o suggerimento...',
    'support.selectProduct': 'Seleziona Prodotto',
    'support.noProduct': 'Nessuno',
    'support.selectCategory': 'Seleziona Categoria',
    'support.categoryRequired': 'Seleziona una categoria',
    'support.announcementAdminOnly': 'Solo gli admin possono pubblicare annunci',
    'support.titleContentRequired': 'Titolo e contenuto non possono essere vuoti',
    'support.linkDevice': 'Collega Dispositivo',
    'support.linkDeviceDescription': 'Collega un dispositivo per condividere il suo snapshot di stato attuale e le impostazioni con il personale di supporto.',
    'support.selectDevice': 'Seleziona Dispositivo',
    'support.noDevice': 'Nessuno',
    'support.packIndex': 'Indice Pacco Batteria',
    'support.linkedDeviceSnapshot': 'Snapshot Stato Dispositivo Collegato',
    'support.linkedDeviceSettings': 'Snapshot Impostazioni Dispositivo Collegato',
    'support.publicPost': 'Post Pubblico',
    'support.privatePost': 'Post Privato',
    'support.publicDescription': 'Tutti possono vedere questo post',
    'support.privateDescription': 'Solo tu e gli admin possono vedere questo post',
    'support.submitPost': 'Invia Post',
    'support.saveDraft': 'Salva Bozza',
    'support.draftSaved': 'Bozza salvata',
    'support.similarPostsFound': 'Post simili trovati, potrebbero essere già stati risposti:',
    'support.createError': 'Errore creazione post',

    // Phase 2 additions
    'support.myPosts': 'I Miei Post',
    'support.myPostsTab': 'I Miei Post',
    'support.draftsTab': 'Bozze',
    'support.noMyPosts': 'Non hai ancora pubblicato nulla',
    'support.untitledDraft': 'Bozza Senza Titolo',
    'support.lastSaved': 'Ultimo salvataggio',
    'support.continueDraft': 'Continua Modifica',
    'support.deleteDraft': 'Elimina Bozza',
    'support.noDrafts': 'Nessuna bozza salvata',
    'support.addImages': 'Aggiungi Immagini',
    'support.maxFilesError': 'Max {{max}} immagini consentite',
    'support.onlyImagesAllowed': 'Sono consentiti solo file immagine',
    'support.fileTooLarge': 'File troppo grande (max 10MB)',
    'support.uploadFailed': 'Caricamento fallito',
    'common.uploadImages': 'Carica Immagini',

    // Phase 3 additions
    'support.mentioning': 'Menzionando',

    // Phase 4 additions
    'support.adminPanel': 'Gestione Supporto',
    'support.tagsTab': 'Gestione Tag',
    'support.templatesTab': 'Template Risposte',
    'support.reportsTab': 'Gestione Segnalazioni',
    'support.addTag': 'Aggiungi Tag',
    'support.editTag': 'Modifica Tag',
    'support.tagType': 'Tipo Tag',
    'support.tagColor': 'Colore Tag',
    'support.confirmDeleteTag': 'Eliminare questo tag?',
    'support.addTemplate': 'Aggiungi Template',
    'support.editTemplate': 'Modifica Template',
    'support.templateContent': 'Contenuto Template',
    'support.templatePreview': 'Anteprima',
    'support.templatePlaceholder': 'Supporta formato Markdown...',
    'support.noTemplates': 'Nessun template',
    'support.confirmDeleteTemplate': 'Eliminare questo template?',
    'support.useTemplate': 'Usa Template',
    'support.loadTemplatesError': 'Errore caricamento template',
    'support.filterStatus': 'Filtra Stato',
    'support.reportedContent': 'Contenuto Segnalato',
    'support.reportReason': 'Motivo Segnalazione',
    'support.reporter': 'Segnalatore',
    'support.reportPending': 'In Attesa',
    'support.reportReviewed': 'Revisionato',
    'support.reportDismissed': 'Scartato',
    'support.markReviewed': 'Segna come Revisionato',
    'support.dismissReport': 'Scarta Segnalazione',
    'support.noReports': 'Nessuna segnalazione',

    // API Keys
    'apiKeys.menuTitle': 'Chiavi API',
    'apiKeys.title': 'Chiavi API',
    'apiKeys.description': 'Gestisci chiavi di accesso per integrazioni di terze parti',
    'apiKeys.usageWarning': 'Usa le Chiavi API per autenticare applicazioni esterne come Home Assistant o Grafana senza necessità di login. Tieni le tue chiavi segrete!',
    'apiKeys.myKeys': 'Le Mie Chiavi',
    'apiKeys.generateKey': 'Genera Chiave',
    'apiKeys.keyName': 'Nome',
    'apiKeys.created': 'Creato',
    'apiKeys.lastUsed': 'Ultimo Uso',
    'apiKeys.noKeys': 'Nessuna chiave API trovata',
    'apiKeys.integrationExamples': 'Esempi di Integrazione',
    'apiKeys.haTitle': 'Home Assistant (Sensore REST)',
    'apiKeys.haInstructions': 'Aggiungi questo al tuo configuration.yaml:',
    'apiKeys.curlTitle': 'cURL / Terminale',
    'apiKeys.generateDialogTitle': 'Genera Chiave API',
    'apiKeys.keyNameLabel': 'Nome Chiave (es. Home Assistant)',
    'apiKeys.generateAction': 'Genera',
    'apiKeys.successDialogTitle': 'Chiave API Generata',
    'apiKeys.copyWarning': 'Copia questa chiave ora. Non potrai vederla di nuovo!',
    'apiKeys.createError': 'Errore creazione chiave API',
    'apiKeys.deleteError': 'Errore eliminazione chiave',
    'apiKeys.loadError': 'Errore caricamento chiavi API',

    // Impostazioni
    'settings.deleteAccount': 'Elimina account',
    'settings.deleteAccountDesc': 'Una volta eliminato il tuo account, non potrai tornare indietro. Per favore, sii certo.',
    'settings.deleteAccountConfirm': 'Sei sicuro di voler eliminare il tuo account?',
    'settings.deleteAccountWarning': 'Questa azione è permanente e non può essere annullata.',
    'settings.deleteAccountSuccess': 'Account eliminato con successo',
  },
  // App specific
};

export default it;
